import React from 'react';
import { 
    Card, 
    CardContent, 
    CardHeader,
    Button,
    Grid,
    Box
} from '@mui/material';
import { 
    Add,
    Schedule,
    Analytics,
    Settings
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

const QuickActions: React.FC = () => {
    const actions = [
        {
            title: 'Create New Game',
            description: 'Add a new game with questions',
            icon: <Add />,
            color: 'primary' as const,
            link: '/games/new'
        },
        {
            title: 'Schedule Game',
            description: 'Set up game timing',
            icon: <Schedule />,
            color: 'secondary' as const,
            link: '/manageschedule'
        },
        {
            title: 'View Analytics',
            description: 'Player statistics and insights',
            icon: <Analytics />,
            color: 'success' as const,
            link: '#',
            disabled: true
        },
        {
            title: 'System Settings',
            description: 'Configure application settings',
            icon: <Settings />,
            color: 'warning' as const,
            link: '#',
            disabled: true
        }
    ];

    return (
        <Card sx={{ height: '100%' }}>
            <CardHeader 
                title="Quick Actions" 
                titleTypographyProps={{ variant: 'h6' }}
            />
            <CardContent>
                <Grid container spacing={2}>
                    {actions.map((action, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Button
                                component={action.disabled ? 'button' : Link}
                                to={action.disabled ? undefined : action.link}
                                variant="outlined"
                                color={action.color}
                                disabled={action.disabled}
                                startIcon={action.icon}
                                sx={{ 
                                    width: '100%',
                                    height: 80,
                                    flexDirection: 'column',
                                    gap: 1,
                                    textTransform: 'none'
                                }}
                            >
                                <Box sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                                    {action.title}
                                </Box>
                                <Box sx={{ fontSize: '0.75rem', opacity: 0.7 }}>
                                    {action.description}
                                </Box>
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default QuickActions;